import script from "./Post.vue?vue&type=script&setup=true&lang=js"
export * from "./Post.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=da7fa63e&lang=scss&scoped=true"
import "./Post.vue?vue&type=style&index=1&id=da7fa63e&scoped=true&lang=css"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da7fa63e"]])

export default __exports__